var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "position-relative d-inline-block mr-1",
      on: {
        click: function ($event) {
          $event.stopPropagation()
          $event.preventDefault()
        },
      },
    },
    [
      _c(
        "button",
        {
          staticClass: "btn btn-light border",
          on: {
            click: function ($event) {
              $event.stopPropagation()
              $event.preventDefault()
              _vm.expanded = !_vm.expanded
            },
          },
        },
        [
          _vm._v(
            "\n        " + _vm._s(_vm._f("trans")("Presets")) + "\n        "
          ),
          _c("i", {
            staticClass: "font-md",
            class: {
              "fa fa-chevron-down": !_vm.expanded,
              "fa fa-chevron-up": _vm.expanded,
            },
          }),
        ]
      ),
      _vm._v(" "),
      _vm.expanded
        ? _c(
            "div",
            {
              staticClass:
                "dropdown-menu dropdown-menu-right br-8 show vue-preset-dropdown",
            },
            [
              _vm.isStatusDone
                ? [
                    _vm._l(_vm.presets, function (preset) {
                      return preset.target === _vm.target
                        ? _c("PresetItem", {
                            key: preset.id_preset,
                            ref: "PresetItem",
                            refInFor: true,
                            attrs: { preset: preset },
                            on: {
                              "delete-preset": _vm.deletePreset,
                              "update-preset": _vm.initPatchPreset,
                              "select-preset": _vm.setOptionsFromPreset,
                              "change-preset-name": _vm.changePresetName,
                            },
                          })
                        : _vm._e()
                    }),
                    _vm._v(" "),
                    Array.isArray(_vm.presets) && _vm.presets.length > 0
                      ? _c("div", { staticClass: "dropdown-divider" })
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.patchPresetInit
                      ? _c("form", [
                          _c("div", { staticClass: "form-group" }, [
                            _c("label", { attrs: { for: "preset-input" } }, [
                              _vm._v(_vm._s(_vm._f("trans")("Save preset as"))),
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.presetName,
                                  expression: "presetName",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: {
                                placeholder:
                                  _vm._f("trans")("Enter preset name"),
                                id: "preset-input",
                              },
                              domProps: { value: _vm.presetName },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.presetName = $event.target.value
                                },
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-success m-b-10 m-l-20",
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  $event.preventDefault()
                                  return _vm.savePreset.apply(null, arguments)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm._f("trans")("Save new preset")) +
                                  "\n                "
                              ),
                            ]
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.patchPresetInit
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-success mb-2 ml-2 mt-2",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                $event.preventDefault()
                                return _vm.patchPreset(_vm.presetToUpdate)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm._f("trans")("Update preset")) +
                                "\n            "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                : _vm.isStatusLoading
                ? _c("LoadingAnimation", {
                    attrs: {
                      "animation-style": "bars",
                      classes: "m-b-10 m-t-10",
                    },
                  })
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }